<form (ngSubmit)="processInvoiceDetials()" [formGroup]="invoiceValidationForm">
  <div class="d-flex justify-content-between align-items-center py-2
    ">
    <label class="mb-0" style="font-family: 'Cochin'; font-weight: 800; font-size: 18px;">Validate Invoice
      Number</label>
    <i class="cancel-btn material-symbols-outlined ms-auto pt-2 text-danger" role="button"
      (click)="closeModal()">close</i>

  </div>
  <div class="action-input-group mb-0">
    <div class="input">
      <input class="tax-form-control" type="text" class="mt-0" formControlName="invoiceNumber" appOnlyNumber
        placeholder="Enter Invoice No." />
    </div>
    <app-error-message controlName="invoiceNumber" label="Invoice number"
      [form]="invoiceValidationForm"></app-error-message>
    <button class="gold-btn" [disabled]="invoiceNumberControl.invalid" type="submit">
      <span *ngIf="!isVerifyingAsin">Verify</span>
      <div class="spinner-border text-white" *ngIf="isVerifyingAsin"></div>
    </button>
  </div>
</form>